import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "../result/result.css";
import printJS from 'print-js'; // If using npm
import AlertMessage from "../../AlertMessage";
import moment from 'moment';

function IcseResult() {
  const [academicYear, setAcademicYear] = useState('');
  const [classValue, setClassValue] = useState('');
  const [selectedExamName, setSelectedExamName] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [classes, setClasses] = useState([]);
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [divisionSubjects, setDivisionSubjects] = useState({}); // Store subjects by class and division
  // const [serialNoData, setSerialNoData] = useState({});
  const [dateSelected, setDateSelected] = useState(false);
  const [sansthaName, setSansthaName] = useState('');
  const [taluka, setTaluka] = useState('');
  const [jilha, setJilha] = useState('');
  const [udiseNumberDisplay, setUdiseNumberDisplay] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
const [previousYearClass, setPreviousYearClass] = useState('');
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [examNames, setExamNames] = useState([
    "Semester First ",
    "Semester Second ",
    "Combined Result",
    "Sem I & Sem II",
  ]);

  const examNameTranslations = {
    "Semester First ": "प्रथम सत्र",
    "Semester Second ": "द्वितीय सत्र",

    "Combined Result": "द्वितीय सत्र",
    "Sem I & Sem II": "प्रथम आणि द्वितीय सत्र",
  };


  // IndexedDB constants
  const DB_NAME = 'SchoolManagementDB';
  const STUDENT_STORE = 'studentData';
  const DB_VERSION = 1;
  const SCHOOL_STORE = 'schoolData';

 // Function to open IndexedDB
const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      resolve(db);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      // Create object stores if they don't exist
      if (!db.objectStoreNames.contains(STUDENT_STORE)) {
        db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
      }
      
      // Add SCHOOL_STORE if it doesn't exist
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  const fetchDivisionsForClass = async (classValue) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll(); // Fetch all students

      request.onsuccess = (event) => {
        const students = event.target.result;
        const divisionsForClass = new Set();

        students.forEach((student) => {
          if (student.currentClass === classValue) {
            divisionsForClass.add(student.division);
          }
        });

        setDivisions(Array.from(divisionsForClass)); // Update divisions state
      };

      request.onerror = (event) => {
        console.error("Error fetching divisions from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error opening IndexedDB:", error);
    }
  };

  // Function to fetch student data from IndexedDB
  const fetchStudentData = async (db) => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll();

      request.onsuccess = (event) => {
        const students = event.target.result;
        setStudentData(students);


        const classesAndDivisions = {};
        students.forEach((student) => {
          if (student && student.currentClass) {
            if (!classesAndDivisions[student.currentClass]) {
              classesAndDivisions[student.currentClass] = {};
            }

            const division = student.division || "";
            if (!classesAndDivisions[student.currentClass][division]) {
              classesAndDivisions[student.currentClass][division] = [];
            }

            // Use the ID as the serial number equivalent
            classesAndDivisions[student.currentClass][division].push(student.id);
          }
        });

        // Extract class, division, and srNo from key
        const updatedStudents = students.map(student => {
          const keyParts = student.id.split("-"); // Split by "-"
          const className = keyParts[0]; // First part is class
          const division = keyParts[1]; // Second part is division
          const srNo = keyParts[keyParts.length - 1]; // Last part is srNo
          return { ...student, className, division, srNo };
        });

        setClasses(Object.keys(classesAndDivisions));
        setStudentData(updatedStudents); // Store updated students
        resolve(updatedStudents);
      };

      request.onerror = (event) => {
        console.error("Error fetching student data from IndexedDB:", event.target.error);
        reject(event.target.error);
      };
    });
  };


  // Load student data and marks from IndexedDB
  useEffect(() => {
    const loadData = async () => {
      try {
        const db = await openDB();
        await fetchStudentData(db);
      } catch (error) {
        console.error("Error loading data from IndexedDB:", error);
      }
    };

    loadData();
  }, []);

  // Fetch marks data from IndexedDB when exam name changes
  useEffect(() => {
    if (selectedExamName && classValue && academicYear) {
      const fetchMarks = async () => {
        try {
          const db = await openDB();
          const selectedStudents = studentData.filter(
            (student) => student.currentClass === classValue
          );
          setSelectedStudents(selectedStudents);
          const marksDataPromises = selectedStudents.map(async (student) => {
            const studentMarks = await fetchMarksData(db, student.srNo, academicYear, selectedExamName);
            return { srNo: student.srNo, marks: studentMarks };
          });

          const marksDataArray = await Promise.all(marksDataPromises);
          const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
            acc[srNo] = marks;
            return acc;
          }, {});

          setMarksData(marksData);
        } catch (error) {
          console.error('Error fetching marks data:', error);
        }
      };

      fetchMarks();
    }
  }, [selectedExamName, classValue, academicYear]);



  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();

          if (data) {
            setAcademicYear(data.defaultYear || "");
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  const [subjectSequence, setSubjectSequence] = useState([]); // New state for subject sequence
useEffect(() => {
  if (academicYear && (classValue || previousYearClass) && division) {
    fetchSubjectSequence();
  }
}, [academicYear, classValue, previousYearClass, division]);



 const fetchSubjectSequence = async () => {
  try {
    const classToUse = previousYearClass || classValue;
    const divisionToUse = division;
    
    if (!academicYear || !classToUse || !divisionToUse) return;

    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classToUse}/${divisionToUse}.json`
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch subject sequence');
    }
    
    const data = await response.json();
    const orderedSubjects = Object.keys(data)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => data[key]);
    
    setSubjectSequence(orderedSubjects);
  } catch (error) {
    console.error('Error fetching subject sequence:', error);
    // Optionally set a default subject sequence or show an error message
    setSubjectSequence([]);
  }
};


  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);


const fetchSchoolName = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, 'readonly');
    const store = transaction.objectStore(SCHOOL_STORE);
    
    // Get the school data using the udiseNumber as key
    const request = store.get(udiseNumber);

    request.onsuccess = (event) => {
      const schoolData = event.target.result;
      if (schoolData) {
        // Set school name and logo from IndexedDB
        setSchoolName(schoolData.schoolName || '-');
        setSchoolLogo(schoolData.schoolLogo || '');
        
        // Update language if available in school data
        if (schoolData.language) {
          setLanguage(schoolData.language);
          localStorage.setItem('language', schoolData.language);
        }
      } else {
        console.log('No school data found in IndexedDB');
        // Fallback to empty values if no data found
        setSchoolName('-');
        setSchoolLogo('');
      }
    };

    request.onerror = (event) => {
      console.error('Error fetching school data from IndexedDB:', event.target.error);
      // Fallback to empty values on error
      setSchoolName('-');
      setSchoolLogo('');
    };
  } catch (error) {
    console.error('Error accessing IndexedDB:', error);
    // Fallback to empty values on error
    setSchoolName('-');
    setSchoolLogo('');
  }
};
  
    useEffect(() => {
    fetchSchoolName();
  }, [udiseNumber]); // Add udiseNumber as dependency


  const handleAcademicYearChange = (e) => setAcademicYear(e.target.value);


  const handleClassChange = async (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass); // Update the class value
    setDivision(""); // Reset division when class changes

    if (selectedClass) {
      await fetchDivisionsForClass(selectedClass);
    }
  };

  const handleExamNameChange = (e) => {
    setSelectedExamName(e.target.value);
  };

  const filteredExamNames = examNames.filter((examName) => examName === "Semester Second ");

  const fetchSubjectsForClassAndDivision = async (classValue, division) => {
    try {
      if (!classValue || !division || !academicYear) {
        console.error("Class, division, or academic year not set");
        return;
      }

      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classValue}/${division}.json`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch subjects for class ${classValue} and division ${division}`);
      }
      const subjectsData = await response.json();
      if (subjectsData) {
        const validSubjects = Object.entries(subjectsData)
          .filter(([_, value]) => value !== null && value !== undefined)
          .map(([_, subject]) => subject);

        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: validSubjects,
          },
        }));
      } else {
        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: [],
          },
        }));
      }
    } catch (error) {
      console.error(`Error fetching subjects: ${error}`);
    }
  };

  // Fetch subjects when class or division changes
  useEffect(() => {
    if (classValue && division) {
      fetchSubjectsForClassAndDivision(classValue, division);
    }
  }, [classValue, division, academicYear]);


  const fetchMarksData = async (db, srNo, academicYear, examName) => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.get(srNo);

      request.onsuccess = (event) => {
        const student = event.target.result;
        if (student && student.icseResult && student.icseResult[academicYear] && student.icseResult[academicYear][examName]) {
          const marks = student.icseResult[academicYear][examName];
          const subjectMarks = { ...marks }; // Include all fields including 'remark'
          resolve(subjectMarks);
        } else {
          resolve({}); // Return an empty object if marks data is not found
        }
      };

      request.onerror = (event) => {
        console.error("Error fetching marks data from IndexedDB:", event.target.error);
        reject(event.target.error);
      };
    });
  };


  const viewResult = async (srNo) => {
    try {
      console.log("Clicked SR No:", srNo);
      console.log("Selected Students:", selectedStudents);

      // Ensure selectedStudents has data
      if (!selectedStudents || selectedStudents.length === 0) {
        setAlertMessage("No student data available. Please load students first.");
        return;
      }

      // Extract only the srNo (last part after the last "-")
      const extractedSrNo = srNo.split("-").pop();
      console.log("Extracted SR No:", extractedSrNo);

      // Find student by extracted SR No
      const student = selectedStudents.find((student) => student.srNo === extractedSrNo);
      console.log("Matched Student:", student);

      if (!student) {
        setAlertMessage(`Student with SR No: ${extractedSrNo} not found!`);
        return;
      }

      // Open IndexedDB
      const db = await openDB();
      console.log("Database Opened:", db);

      // Fetch marks from IndexedDB
      // Fetch marks from IndexedDB
      const [
        firstSemesterData,
        secondSemesterData,
        unitTestIData,
        unitTestIIData,
        unitTestIIIData,
        unitTestIVData,
      ] = await Promise.all([
        fetchMarksData(db, srNo, academicYear, "Semester First "),
        fetchMarksData(db, srNo, academicYear, "Semester Second "),
        fetchMarksData(db, srNo, academicYear, "Unit Test I"),
        fetchMarksData(db, srNo, academicYear, "Unit Test II"),
        fetchMarksData(db, srNo, academicYear, "Unit Test III"),
        fetchMarksData(db, srNo, academicYear, "Unit Test IV"),
      ]);

      console.log("Fetched Marks Data:");
      console.log("First Semester:", firstSemesterData);
      console.log("Second Semester:", secondSemesterData);
      console.log("Unit Test I:", unitTestIData);
      console.log("Unit Test II:", unitTestIIData);
      console.log("Unit Test III:", unitTestIIIData);
      console.log("Unit Test IV:", unitTestIVData);

      // Check if all fetched data is empty
      const isEmpty = (obj) => !obj || Object.keys(obj).length === 0;

      if (
        isEmpty(firstSemesterData) &&
        isEmpty(secondSemesterData) &&
        isEmpty(unitTestIData) &&
        isEmpty(unitTestIIData) &&
        isEmpty(unitTestIIIData) &&
        isEmpty(unitTestIVData)
      ) {
        setAlertMessage("No marks data found. Please enter marks to view the result.");
        return;
      }

      const resultsWithTotal = {};

      // Combine subjects across all datasets
      const allSubjects = new Set([
        ...Object.keys(firstSemesterData || {}),
        ...Object.keys(secondSemesterData || {}),
        ...Object.keys(unitTestIData || {}),
        ...Object.keys(unitTestIIData || {}),
        ...Object.keys(unitTestIIIData || {}),
        ...Object.keys(unitTestIVData || {}),
      ]);

      console.log("secondSemesterData----------", secondSemesterData);

      // Aggregate marks for each subject
      allSubjects.forEach((subject) => {
        if (subject) {
          resultsWithTotal[subject] = {
            obtainMarks: secondSemesterData?.[subject]?.obtainMarks || 0,
            outOf: secondSemesterData?.[subject]?.outOf || 0,
            firstSemesterObtainMarks: firstSemesterData?.[subject]?.obtainMarks || 0,
            firstSemesterOutOf: firstSemesterData?.[subject]?.outOf || 0,
            unitTestIObtainMarks: unitTestIData?.[subject]?.obtainMarks || 0,
            unitTestIOutOf: unitTestIData?.[subject]?.outOf || 0,
            unitTestIIObtainMarks: unitTestIIData?.[subject]?.obtainMarks || 0,
            unitTestIIOutOf: unitTestIIData?.[subject]?.outOf || 0,
            unitTestIIIObtainMarks: unitTestIIIData?.[subject]?.obtainMarks || 0,
            unitTestIIIOutOf: unitTestIIIData?.[subject]?.outOf || 0,
            unitTestIVObtainMarks: unitTestIVData?.[subject]?.obtainMarks || 0,
            unitTestIVOutOf: unitTestIVData?.[subject]?.outOf || 0,
            firstSemesterGrade: firstSemesterData?.[subject]?.grade,
            secondSemesterGrade: secondSemesterData?.[subject]?.grade,          };
        }
      });

      console.log("Final Results Data:", resultsWithTotal);

      // Set state for selected student results
      setSelectedStudentResults({
        studentName: student.stdName,
        results: resultsWithTotal,
        stdMother: student.stdMother,
        stdFather: student.stdFather,
        stdSurname: student.stdSurname,
        dob: student.dob,
        division: student.division,
        motherTounge: student.motherTounge,
        studentId: student.studentId,
        gender: student.gender,
        registerNo: student.registerNo,
        rollNo: student.rollNo,
        stdPhoto: student.stdPhoto,
        currentClass: student.currentClass,
srNostd:student.serialNo,
        // Add the remarks
        firstSemesterRemark: firstSemesterData?.remark || '',
        secondSemesterRemark: secondSemesterData?.remark || '',
      });

      console.log("Opening Modal...");
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student results:", error);
      setAlertMessage("An error occurred. Please try again.");
    }
  };

  const calculateGradeEnglish = (total) => {
    if (total >= 90) return 'A+';
    if (total >= 80) return 'A';
    if (total >= 70) return 'B+';
    if (total >= 60) return 'B';
    if (total >= 50) return 'C+';
    if (total >= 40) return 'C';
    if (total >= 30) return 'D+';
    if (total >= 20) return 'D';
    return 'Fail';
  };

  const calculateGradeMarathi = (total) => {
    if (total >= 90) return 'अ-1';
    if (total >= 80) return 'अ-2';
    if (total >= 70) return 'ब-1';
    if (total >= 60) return 'ब-2';
    if (total >= 50) return 'क-1';
    if (total >= 40) return 'क-2';
    if (total >= 30) return 'ड-1';
    if (total >= 20) return 'ड-2';
    return 'नापास';
  };

  // Function to calculate grade based on the current language
  const calculateGrade = (total) => {
    return language === 'English' ? calculateGradeEnglish(total) : calculateGradeMarathi(total);
  };

  const handleCloseModal = () => setShowModal(false);

  const handlePrint = async () => {
    try {
      const printContent = document.querySelector('.modal-body'); // Select the modal body content
      const attendanceInput = document.getElementById('attendance');


      if (!printContent) {
        console.error('Print content not found');
        return;
      }

      // Clone the print content and apply styles
      const clone = printContent.cloneNode(true);

      // Remove print button from the cloned content - Make sure this selector matches your print button
      clone.querySelectorAll('.no-print, button, .print-btn, [type="button"]').forEach(element => {
        element.remove();
      });

      // Find the attendance input in the clone and replace it with a static text element
      const clonedAttendanceInput = clone.querySelector('#attendance');
      if (clonedAttendanceInput) {
        // Get the current value from the original input
        const attendanceValue = attendanceInput ? attendanceInput.value : '';

        // Create a replacement span with the attendance value
        const attendanceSpan = document.createElement('span');
        attendanceSpan.textContent = attendanceValue || 'Not specified';
        attendanceSpan.style.borderBottom = '1px solid #000';
        attendanceSpan.style.padding = '0 5px';
        const attendanceContainer = clonedAttendanceInput.parentNode;
        attendanceContainer.replaceChild(attendanceSpan, clonedAttendanceInput);
      }




      // Apply scaling with increased size
      clone.style.padding = "10px"; // Add padding to balance scaling
      clone.style.margin = "0 auto"; // Center the content
      clone.style.transform = "scale(1.2)"; // Increase scale size
      clone.style.transformOrigin = "top center"; // Scale from the center-top
      clone.style.width = "fit-content"; // Ensure it doesn't overflow horizontally

      // Reset unnecessary styles to avoid blank space
      clone.querySelectorAll('p').forEach(p => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.4";
      });

      // Create a temporary container for the clone
      const printContainer = document.createElement("div");
      printContainer.style.margin = "0 auto"; // Center container
      printContainer.appendChild(clone);

      // Use printJS to print the content
      printJS({
        printable: printContainer.innerHTML,
        type: 'raw-html',
        style: `
                @media print {
                    body { margin: 0; padding: 0; }
                    p { margin: 0; padding: 0; line-height: 1.4; }

 .table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
  font-size: 12px
}

.table th {
  background-color: #f2f2f2;
  font-weight: bold;
    font-size: 12px
}

.table thead th {
  vertical-align: middle;
}

.table tbody td {
  vertical-align: middle;
}

.text-center {
  text-align: center;
}


                    .school-info {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                    }

                    .school-info img {
                        width: 100px;
                        height: 100px;
                        object-fit: cover;
                        margin-right: 20px;
                    }

                    .grad{
  position: absolute; /* add this */
  bottom: 25px; /* add this */
  left: 20px; /* add this */
  width: 90%; /* add this */
}


                  .parent-area{
                      margin-top:10px !important;
                      padding-top:8px  !important;
                  }

                    @page {
                        margin: 0; /* Remove default page margins */
                    }
                }
            `
      });
    } catch (error) {
      console.error('Error in handlePrint:', error);
    }
  };


  const handlePrit = async () => {
    try {
      const printContent = document.querySelector('.modal-body'); // Select the modal body content
      const attendanceInput = document.getElementById('attendance');
      const remarkInput = document.getElementById('remark-input');
      const dateInput = document.getElementById('date'); // Get the date input element

      if (!printContent) {
        console.error('Print content not found');
        return;
      }

      // Clone the print content and apply styles
      const clone = printContent.cloneNode(true);

      // Remove print button from the cloned content - Make sure this selector matches your print button
      clone.querySelectorAll('.no-print, button, .print-btn, [type="button"]').forEach(element => {
        element.remove();
      });


      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };
  

      // Find the attendance input in the clone and replace it with a static text element
      const clonedAttendanceInput = clone.querySelector('#attendance');
      if (clonedAttendanceInput) {
        const attendanceValue = attendanceInput ? attendanceInput.value : '';

        // Create a replacement span with the attendance value
        const attendanceSpan = document.createElement('span');
        attendanceSpan.textContent = attendanceValue || 'Not specified';
        attendanceSpan.style.borderBottom = '1px solid transparent';
        attendanceSpan.style.padding = '0 5px';


        // Replace the input with the span
        const attendanceContainer = clonedAttendanceInput.parentNode;
        attendanceContainer.replaceChild(attendanceSpan, clonedAttendanceInput);
      }


      // Replace Remark input with span
      const clonedRemarkInput = clone.querySelector('#remark-input');
      if (clonedRemarkInput) {
        const remarkValue = remarkInput?.value || 'Not specified';
        const span = document.createElement('span');
        span.textContent = remarkValue;
        span.style.padding = '0 5px';

        clonedRemarkInput.parentNode.replaceChild(span, clonedRemarkInput);
      }

      // Find the date input in the clone and replace it with a static text element
      const clonedDateInput = clone.querySelector('#date');
      if (clonedDateInput) {
        const dateValue = dateInput ? dateInput.value : '';

        // Create a replacement span with the date value
        const dateSpan = document.createElement('span');
        dateSpan.textContent = formatDate(dateValue) || 'Not specified';
        dateSpan.style.padding = '0 5px';

        // Replace the input with the span
        const dateContainer = clonedDateInput.parentNode;
        dateContainer.replaceChild(dateSpan, clonedDateInput);
      }

      // Apply scaling with reduced size
      clone.style.padding = "15px";
      clone.style.margin = "0 auto";
      clone.style.transform = "scale(1.1)";
      clone.style.transformOrigin = "top center";
      clone.style.width = "fit-content";

      // Reset unnecessary styles
      clone.querySelectorAll('p').forEach(p => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.3";
        p.style.fontSize = "12px";
      });

      // Create a temporary container for the clone
      const printContainer = document.createElement("div");
      printContainer.style.margin = "0 auto";
      printContainer.appendChild(clone);

      // Use printJS to print the content
      printJS({
        printable: printContainer.innerHTML,
        type: 'raw-html',
        style: `
    @media print {
        .no-print, button, .print-btn, input[type="button"], input[type="submit"] { 
            display: none !important; 
            visibility: hidden !important;
        } 
        
        body { margin: 0; padding: 0; font-size: 14px; }
        p { margin: 0; padding: 0; line-height: 1.3; font-size: 14px; }
        
        .table {
            width: 100%;
            border-collapse: collapse;
        }

        .table th, .table td {
            border: 1px solid #000;
            padding: 5px;
            text-align: center;
            font-size: 12px;
        }

        .table th {
            background-color: #f2f2f2;
            font-weight: bold;
            font-size: 12px;
        }

        .table thead th,
        .table tbody td {
            vertical-align: middle;
        }

        .text-center {
            text-align: center;
        }

        .school-info {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
        }

        .school-info img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            margin-right: 15px;
        }

        .grad {
            position: absolute;
            bottom: 20px;
            left: 15px;
            width: 90%;
        }
.parent-area{
                      margin-top:10px !important;
                      padding-top:8px  !important;
                  }
        @page {
            margin: 0;
        }
    }
`

      });
    } catch (error) {
      console.error('Error in handlePrint:', error);
    }
  };


  

  const storeStudentADRInIndexedDB = async (studentId, academicYear, examName, attendance, date, remark) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readwrite");
      const store = transaction.objectStore(STUDENT_STORE);
      
      // Get the current student data using the correct key format (studentId)
      const request = store.get(studentId);
      
      request.onsuccess = (event) => {
        let studentData = event.target.result;
        
        if (!studentData) {
          console.error("Student not found with ID:", studentId);
          return;
        }
        
        // Initialize the stdADR structure if it doesn't exist
        if (!studentData.stdADR) {
          studentData.stdADR = {};
        }
        
        if (!studentData.stdADR[academicYear]) {
          studentData.stdADR[academicYear] = {};
        }
        
        // Update the ADR data
        studentData.stdADR[academicYear][examName] = {
          attendance,
          date,
          remark
        };
        
        // Save the updated student data
        const updateRequest = store.put(studentData);
        
        updateRequest.onsuccess = () => {
          console.log("ADR data saved to IndexedDB successfully");
        };
        
        updateRequest.onerror = (error) => {
          console.error("Error saving ADR data to IndexedDB:", error);
        };
      };
      
      request.onerror = (event) => {
        console.error("Error retrieving student data for ADR update:", event.target.error);
      };
    } catch (error) {
      console.error("Error saving ADR data to IndexedDB:", error);
    }
  };
  
  // Fixed Firebase storage function
  const storeStudentADRInFirebase = async (udiseNumber, srNo, academicYear, examName, attendance, date, remark) => {
    try {
      // Make sure srNo is properly formatted (just the number)
      const formattedSrNo = srNo.toString();
      
      // Construct the Firebase URL
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/stdADR/${academicYear}/${examName}.json`;
      
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attendance,
          date,
          remark
        })
      });
      
      if (!response.ok) {
        throw new Error(`Failed to save ADR data to Firebase: ${response.statusText}`);
      }
      
      console.log("ADR data saved to Firebase successfully");
    } catch (error) {
      console.error("Error saving ADR data to Firebase:", error);
    }
  };
  
  // Updated function to handle saving attendance, date, and remark
  const handleSaveADR = () => {
    if (!selectedStudentResults || !academicYear || !selectedExamName) {
      console.error("Missing required data to save ADR");
      return;
    }
    
    console.log("Saving ADR data for:", selectedStudentResults);
    
    // Store in IndexedDB - using the correct student ID format 
    // (which appears to be in the format "Class IX-A-211")
    storeStudentADRInIndexedDB(
      selectedStudentResults.studentId || `${selectedStudentResults.currentClass}-${selectedStudentResults.division}-${selectedStudentResults.srNostd}`,
      academicYear,
      selectedExamName,
      attendance,
      selectedDate,
      remarkText
    );
    
    // Store in Firebase - using the numerical srNo
    storeStudentADRInFirebase(
      udiseNumber, 
      selectedStudentResults.srNostd,
      academicYear,
      selectedExamName,
      attendance,
      selectedDate,
      remarkText
    );
    
    // Provide feedback to the user
    setAlertMessage("Attendance, date and remark saved successfully!");
  };

// Add this to your component
const [attendance, setAttendance] = useState("");
const [remarkText, setRemarkText] = useState("");
const [selectedDate, setSelectedDate] = useState("");



// Function to fetch student ADR data from Firebase
const fetchStudentADRFromFirebase = async (udiseNumber, srNo, academicYear, examName) => {
  try {
    // Make sure srNo is properly formatted (just the number)
    const formattedSrNo = srNo.toString();
    
    // Construct the Firebase URL
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${formattedSrNo}/stdADR/${academicYear}/${examName}.json`;
    console.log("url",url);
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch ADR data from Firebase: ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log("ADR data fetched from Firebase:", data);
    
    // If data is null, return null to indicate no data found
    if (!data) {
      return null;
    }
    
    return {
      attendance: data.attendance || "",
      date: data.date || "",
      remark: data.remark || ""
    };
  } catch (error) {
    console.error("Error fetching ADR data from Firebase:", error);
    return null;
  }
};

useEffect(() => {
  if (studentData && studentData.length > 0) {
    // Rest of your code here...
  }
}, [studentData]);


// Add this to your useEffect that runs when selectedStudentResults changes
useEffect(() => {
  if (selectedStudentResults && academicYear && selectedExamName) {
    // Fetch existing ADR data
    console.log("selectedStudentResults",selectedStudentResults);
    
    const fetchADRData = async () => {
      const adrData = await fetchStudentADRFromFirebase(
        udiseNumber,
        selectedStudentResults.srNostd,
        academicYear,
        selectedExamName
      );
      
      if (adrData) {
        setAttendance(adrData.attendance || "");
        setSelectedDate(adrData.date || "");
        setRemarkText(adrData.remark || "");
      } else {
        // Reset fields if no data found
        setAttendance("");
        setSelectedDate("");
        setRemarkText("");
      }
    };
    
    fetchADRData();
  }
}, [selectedStudentResults, academicYear, selectedExamName]);


  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />

      <div className=' main-content-of-page'>
        <h3 style={{ color: 'rgb(27, 67, 50)', textAlign: 'center' }}> {language === "English" ? " Exam Result " : "परीक्षेचा निकाल"}</h3>
        <table className="table table-striped table-bordered">
          <tbody>
            <tr>
              <th style={{ width: 'calc(100% / 7)' }}> {language === "English" ? "Year " : "शैक्षणिक वर्ष  "}</th>
              <td>
                <select
                  id="academicYear"
                  defaultValue={academicYear} // Add this prop
                  value={academicYear}
                  onChange={handleAcademicYearChange}
                  className="form-control custom-select"
                >
                  <option >{language === "English" ? "Select Year " : "वर्ष निवडा "}</option>
                  <option value="2023-2024" >2023-2024</option>
                  <option value="2024-2025" selected>2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </td>
            </tr>
            <tr>
              <th> {language === "English" ? "Class " : "वर्ग"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Class " : "वर्ग निवडा"}</option>
                  {classes.map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Division " : "तुकडी"}</th>
              <td>
                <select
                  id="division"
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Division " : "तुकडी निवडा"}</option>
                  {divisions.map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Exam Name " : "परीक्षा"}</th>
              <td>
                <select
                  id="examName"
                  value={selectedExamName}
                  onChange={handleExamNameChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Exam" : "परीक्षा निवडा"}</option>
                  {examNames.map((examName, index) => (
                    <option key={index} value={examName}>
                      {language === "English" ? examName : examNameTranslations[examName]}
                    </option>
                  ))}
                </select>
              </td>
            </tr>


                 {/* Add this new row for previous year class selection */}
    {academicYear && academicYear !== "2025-2026" && (
      <tr>
        <th>{language === "English" ? "Previous Year Class" : "मागील वर्षाचा वर्ग"}</th>
        <td>
          <select
            value={previousYearClass}
            onChange={(e) => setPreviousYearClass(e.target.value)}
            className="form-control custom-select"
          >
            <option value="">{language === "English" ? "Select Class For Previous Result " : "मागील वर्षाचा वर्ग निवडा"}</option>
            {classes.map((cls, index) => (
              <option key={index} value={cls}>
                {cls}
              </option>
            ))}
          </select>
        </td>
      </tr>
    )}
          </tbody>
        </table>
{selectedStudents.length > 0 && (
  <div className="mt-4">
    <table className="table table-striped table-bordered custom-table">
      <thead>
        <tr>
          <th className="custom-width">{language === "English" ? "Roll No " : "हजेरी क्र"}</th>
          <th>{language === "English" ? "Student's Name " : "विद्यार्थ्याचे नाव"}</th>
          <th>{language === "English" ? "icseResult " : "प्रगतीपत्रक"}</th>
        </tr>
      </thead>
      <tbody>
        {selectedStudents
          .filter((student) => student.division === division && student.isActive !== false)
          .sort((a, b) => a.rollNo - b.rollNo)
          .map((student) => (
            <tr key={student.srNo}>
              <td>{student.rollNo}</td>
              <td>{student.stdName} {student.stdSurname}</td>
              <td>
                <button 
                  className="btn btn-primary" 
                  onClick={() => viewResult(student.id)}
                >
                  {language === "English" ? "View icseResult" : "प्रगति पत्रक"}
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
)}

        <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
          <Modal.Header closeButton>
            <Modal.Title>{language === "English" ? "Exam Result " : "विद्यार्थ्यांचे निकाल"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            {selectedExamName === 'Semester Second ' && selectedStudentResults ? (
              <div>
                {/* Semester Second  modal content */}
                <div className="r mt-1" style={{}}>
                  <div className="left" style={{
                    width: '615px',
                    height: '900px',
                    margin: '0 auto', // Center the div horizontally
                    padding: '20px', // Add some padding
                    border: '2px solid #000', // Optional: Add a border for visibility
                    boxSizing: 'border-box', // Include padding and border in the element's total width and height
                    overflow: 'hidden' // Prevent overflow if content is too large
                  }}>

                    <div className="school-info">
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{ width: '70px', height: 'auto', objectFit: 'contain', marginLeft: '-10px' }}
                          />
                        </div>
                      )}

                      <h6 style={{ fontSize: '18px' }}>{schoolName}</h6>
                    </div>

                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "SECOND SEMESTER " : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `REPORT CARD ACADEMIC YEAR ${academicYear}` : `द्वितीय सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "GR No: " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                   <div style={{ flex: '1', textAlign: 'right' }}>
  <label htmlFor="class" style={{ fontSize: '14px' }}>
    {language === "English" ? "  " : "वर्ग : "}
  </label>
  <span>
    {/* Show current class or previous year class if available */}
    {previousYearClass 
      ? `${previousYearClass} `
      : classValue || '-'}
    {/* Show division if available */}
    {selectedStudentResults?.division ? ` ${selectedStudentResults.division}` : ''}
  </span>
</div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student's Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother's Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>
                            {selectedStudentResults?.dob ?
                              `${new Date(selectedStudentResults.dob).getDate().toString().padStart(2, '0')}/${(new Date(selectedStudentResults.dob).getMonth() + 1).toString().padStart(2, '0')}/${new Date(selectedStudentResults.dob).getFullYear()}`
                              : '-'}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>
                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                        <thead>
                          <tr>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test III" : "तिसरी चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test IV" : "चौथी चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Semester II" : "द्वितीय सत्र"}</th>
                            <th colSpan="3" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grand Total" : "एकूण गुण"}</th>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
                          </tr>
                          <tr>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "%" : "%"}</th>
                          </tr>
                        </thead>




                        <tbody>
                          {selectedStudentResults && selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                // Remove subjects if all relevant marks are null/undefined
                                return grades && (
                                  grades.unitTestIIIObtainMarks ||
                                  grades.unitTestIVObtainMarks ||
                                  grades.obtainMarks
                                );
                              })
                              .map((subject) => {
                                const grades = selectedStudentResults.results[subject];

                                // Calculate row-wise totals
                                const totalOutOf = (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                const totalObtainMarks = (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                const rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                                const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      {subject.length > 20 ? (
                                        (() => {
                                          const words = subject.split(' ');
                                          let firstLine = '';
                                          let secondLine = '';
                                          let currentLength = 0;

                                          for (let i = 0; i < words.length; i++) {
                                            if (currentLength + words[i].length > 20) {
                                              secondLine = words.slice(i).join(' ');
                                              break;
                                            }
                                            firstLine += (i > 0 ? ' ' : '') + words[i];
                                            currentLength += words[i].length + (i > 0 ? 1 : 0);
                                          }

                                          return (
                                            <>
                                              {firstLine}<br />{secondLine}
                                            </>
                                          );
                                        })()
                                      ) : (
                                        subject
                                      )}
                                    </td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIIOutOf || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIIObtainMarks || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIVOutOf || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIVObtainMarks || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.outOf || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.obtainMarks || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}><b>{totalOutOf}</b></td>
                                    <td style={{ padding: "2px" }}><b>{totalObtainMarks}</b></td>
                                    <td style={{ padding: "2px" }}><b>{rowPercentage}</b></td>
                                    <td style={{ padding: "2px" }}><b>{grade}</b></td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ padding: "5px" }}>
                                {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}

                          {selectedStudentResults && selectedStudentResults.results && (
                            <>
                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b>
                                </td>
                                {["unitTestIIIOutOf", "unitTestIIIObtainMarks", "unitTestIVOutOf", "unitTestIVObtainMarks", "outOf", "obtainMarks"].map((key, index) => (
                                  <td key={index} colSpan="1" style={{ padding: "5px" }}>
                                    <b>
                                      {subjectSequence
                                        .filter(subject => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return total + (grades[key] || 0);
                                        }, 0)}
                                    </b>
                                  </td>
                                ))}
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                      }, 0);
                                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                                    })()}
                                  </b>
                                </td>
                              </tr>







                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Remarks" : "शेरा"}</b>
                                </td>

                                {/* Calculate and display the percentage for Unit Test I */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      // Filter subjects that have valid obtainMarks for the student
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        // Check if there is at least one obtainMarks greater than 0
                                        return (
                                          grades.unitTestIIIObtainMarks > 0 ||
                                          grades.unitTestIVObtainMarks > 0 ||
                                          grades.unitTestIIIObtainMarks > 0 ||
                                          grades.unitTestIVObtainMarks > 0 ||
                                          grades.obtainMarks > 0
                                        );
                                      });

                                      // Calculate total out of marks for Unit Test I
                                      const totalUnitTestIOutOf = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIOutOf || 0);
                                      }, 0);

                                      // Calculate total obtained marks for Unit Test I
                                      const totalUnitTestIObtained = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIIObtainMarks || 0);
                                      }, 0);

                                      // Calculate percentage
                                      return totalUnitTestIOutOf > 0 ? ((totalUnitTestIObtained / totalUnitTestIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>

                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      // Filter subjects that have valid obtainMarks for Unit Test II
                                      const filteredSubjectsUnitTestII = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        // Check if there is at least one obtainMarks greater than 0 for Unit Test II
                                        return (
                                          grades.unitTestIVObtainMarks > 0 ||
                                          grades.obtainMarks > 0 // Include subjects with any obtainMarks
                                        );
                                      });

                                      // Calculate total out of marks for Unit Test II
                                      const totalUnitTestIIOutOf = filteredSubjectsUnitTestII.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIVOutOf || 0);
                                      }, 0);

                                      // Calculate total obtained marks for Unit Test II
                                      const totalUnitTestIIObtained = filteredSubjectsUnitTestII.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIVObtainMarks || 0);
                                      }, 0);

                                      // Calculate percentage for Unit Test II
                                      return totalUnitTestIIOutOf > 0 ? ((totalUnitTestIIObtained / totalUnitTestIIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>

                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      // Filter subjects that have valid obtainMarks for Semester I
                                      const filteredSubjectsSemesterI = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        // Check if there is at least one obtainMarks greater than 0 for Semester I
                                        return (
                                          grades.obtainMarks > 0 // Include subjects with any obtainMarks
                                        );
                                      });

                                      // Calculate total out of marks for Semester I
                                      const totalSemesterIOutOf = filteredSubjectsSemesterI.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.outOf || 0);
                                      }, 0);

                                      // Calculate total obtained marks for Semester I
                                      const totalSemesterIObtained = filteredSubjectsSemesterI.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.obtainMarks || 0);
                                      }, 0);

                                      // Calculate percentage for Semester I
                                      return totalSemesterIOutOf > 0 ? ((totalSemesterIObtained / totalSemesterIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>
                                <td colSpan="4" style={{ padding: "5px" }}>
                                  {(() => {
                                    const totalMaxMarks = subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                                    }, 0);
                                    const totalObtainedMarks = subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.obtainMarks || 0);
                                    }, 0);

                                    // Calculate percentage
                                    const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;

                                    // Determine grade based on percentage
                                    const grade = language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);

                                  })()}
                                </td>










                              </tr>
                            </>
                          )}
                        </tbody>

                      </table>
                    ) : (
                      <p style={{ fontSize: '12px' }}>{language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
                    )}
                    <div style={{ marginTop: "10px", fontSize: "14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence
                              .filter(subject => {
                                const grades = selectedStudentResults.results[subject] || {};
                                return grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.obtainMarks;
                              })
                              .reduce((total, subject) => {
                                const grades = selectedStudentResults.results[subject] || {};
                                return total + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.outOf || 0);
                              }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English" ? "Obtained Marks : " : "प्राप्त गुण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults.results[subject] || {};
                              return (
                                total +
                                (grades.unitTestIIIObtainMarks || 0) +
                                (grades.unitTestIVObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <p>
                        <b>
                            {language === "English" ? "First Sem Percentage :  " : "टक्केवारी : "}
                            {(() => {
                              // Filter subjects that have valid obtainMarks for Unit Test I and II
                              const filteredSubjects = subjectSequence.filter(subject => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                // Check if there is at least one obtainMarks greater than 0 for Unit Test I or II
                                return (
                                  grades.unitTestIObtainMarks > 0 ||
                                  grades.unitTestIIObtainMarks > 0 ||
                                  grades.firstSemesterObtainMarks > 0 // Changed from obtainMarks
                                );
                              });

                              // Calculate total maximum marks
                              const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIOutOf || 0) +
                                  (grades.unitTestIIOutOf || 0) +
                                  (grades.firstSemesterOutOf || 0) // Changed from outOf
                                );
                              }, 0);

                              // Calculate total obtained marks
                              const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIObtainMarks || 0) +
                                  (grades.unitTestIIObtainMarks || 0) +
                                  (grades.firstSemesterObtainMarks || 0) // Changed from obtainMarks
                                );
                              }, 0);

                              // Calculate percentage
                              return totalMaxMarks > 0
                                ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                                : "0%";
                            })()}
                          </b>
                        </p>
                        <div>


                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ margin: 0, marginRight: '10px' }}><b>Attendance :</b></p>
                            <input
                              type="text"
                              id="attendance"
                              placeholder="Enter attendance"     value={attendance}
                      onChange={(e) => setAttendance(e.target.value)}
                              style={{
                                border: 'none',
                                borderBottom: '1px solid #ccc',
                                outline: 'none',
                                padding: '5px 0',
                                background: 'transparent',
                                width: '100px' // Add this line to set the width
                              }}
                            />
                          </div>


                        </div>

                      </div>
                    </div>
                    <div>
                      <p>
                        <b>
                          {language === "English" ? "Percentage : " : "टक्केवारी : "}

                          {(() => {
                            // Filter subjects that have valid obtainMarks for Unit Test I and II
                            const filteredSubjects = subjectSequence.filter(subject => {
                              const grades = selectedStudentResults?.results?.[subject] || {};
                              // Check if there is at least one obtainMarks greater than 0 for Unit Test I or II
                              return (
                                grades.unitTestIIIObtainMarks > 0 ||
                                grades.unitTestIVObtainMarks > 0 ||
                                grades.obtainMarks > 0 // Include subjects with any obtainMarks
                              );
                            });

                            // Calculate total maximum marks
                            const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                              const grades = selectedStudentResults?.results?.[subject] || {};
                              return (
                                total +
                                (grades.unitTestIIIOutOf || 0) +
                                (grades.unitTestIVOutOf || 0) +
                                (grades.outOf || 0)
                              );
                            }, 0);

                            // Calculate total obtained marks
                            const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                              const grades = selectedStudentResults?.results?.[subject] || {};
                              return (
                                total +
                                (grades.unitTestIIIObtainMarks || 0) +
                                (grades.unitTestIVObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0);

                            // Calculate percentage
                            return totalMaxMarks > 0
                              ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                              : "0%";
                          })()}

                        </b>
                      </p>








                      <p>
                        <strong>
                          {language === "English" ? "Remark : " : "शेरा : "}
                        </strong>
                        <span>
                          {selectedExamName === "Semester First "
                            ? selectedStudentResults?.firstSemesterRemark || '-'
                            : selectedExamName === "Semester Second "
                              ? selectedStudentResults?.secondSemesterRemark || '-'
                              : '-'}
                        </span>
                      </p>
                    </div>
                    <div
                      className="grad"
                      style={{
                        marginBottom: '50px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                      }}
                    >
                      <label
                        style={{ flex: 1, textAlign: 'left', marginBottom: '2px', marginLeft: '-10px' }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English" ? "Parent's Sign" : "पालकांची सही"}
                      </label>
                      <label
                        style={{ flex: 1, textAlign: 'center', marginBottom: '2px' }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Class Teacher's Sign" : "वर्गशिक्षक"}
                      </label>
                      <label
                        style={{ flex: 1, textAlign: 'right', marginBottom: '2px', marginRight: '20px' }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal's Sign" : "प्राचार्य"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>


            ) : selectedExamName === 'Semester First ' && selectedStudentResults ? (






              <div>
                <div className="r mt-1" style={{}}>
                  <div className="left" style={{
                    width: '615px',
                    height: '900px',
                    margin: '0 auto', // Center the div horizontally
                    padding: '20px', // Add some padding
                    border: '2px solid #000', // Optional: Add a border for visibility
                    boxSizing: 'border-box', // Include padding and border in the element's total width and height
                    overflow: 'hidden' // Prevent overflow if content is too large
                  }}>

                    <div className="school-info" >
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{ width: '70px', height: 'auto', objectFit: 'contain', marginLeft: '-10px' }}
                          />
                        </div>
                      )}

                      <h6 style={{ fontSize: '18px' }}>{schoolName}</h6>
                    </div>

                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "FIRST SEMESTER " : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `REPORT CARD ACADEMIC YEAR ${academicYear}` : `प्रथम सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "GR No: " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right' }}>
  <label htmlFor="class" style={{ fontSize: '14px' }}>
    {language === "English" ? "  " : "वर्ग : "}
  </label>
  <span>
    {/* Show current class or previous year class if available */}
    {previousYearClass 
      ? `${previousYearClass} `
      : classValue || '-'}
    {/* Show division if available */}
    {selectedStudentResults?.division ? ` ${selectedStudentResults.division}` : ''}
  </span>
</div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student's Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother's Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>
                            {selectedStudentResults?.dob ?
                              `${new Date(selectedStudentResults.dob).getDate().toString().padStart(2, '0')}/${(new Date(selectedStudentResults.dob).getMonth() + 1).toString().padStart(2, '0')}/${new Date(selectedStudentResults.dob).getFullYear()}`
                              : '-'}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>
                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                        <thead>
                          <tr>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test I" : "पहिली चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test II" : "दुसरी चाचणी"}</th>
                            <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Semester I" : "प्रथम सत्र"}</th>
                            <th colSpan="3" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grand Total" : "एकूण गुण"}</th>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
                          </tr>
                          <tr>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                            <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "%" : "%"}</th>
                          </tr>
                        </thead>














                        <tbody>
                          {selectedStudentResults && selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                // Only include subjects where at least one of the grade fields has a valid value (not null or undefined)
                                return (
                                  grades && (
                                    grades.unitTestIObtainMarks ||
                                    grades.unitTestIIObtainMarks ||
                                    grades.firstSemesterObtainMarks
                                  )
                                );
                              })
                              .map((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                // Calculate row-wise totals and percentage
                                const totalOutOf =
                                  (grades.unitTestIOutOf || 0) +
                                  (grades.unitTestIIOutOf || 0) +
                                  (grades.firstSemesterOutOf || 0);
                                const totalObtainMarks =
                                  (grades.unitTestIObtainMarks || 0) +
                                  (grades.unitTestIIObtainMarks || 0) +
                                  (grades.firstSemesterObtainMarks || 0);
                                const rowPercentage =
                                  totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                                // Calculate grade based on the row percentage
                                const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      {subject.length > 20 ? (
                                        (() => {
                                          const words = subject.split(' ');
                                          let firstLine = '';
                                          let secondLine = '';
                                          let currentLength = 0;

                                          for (let i = 0; i < words.length; i++) {
                                            if (currentLength + words[i].length > 20) {
                                              secondLine = words.slice(i).join(' ');
                                              break;
                                            }
                                            firstLine += (i > 0 ? ' ' : '') + words[i];
                                            currentLength += words[i].length + (i > 0 ? 1 : 0);
                                          }

                                          return (
                                            <>
                                              {firstLine}<br />{secondLine}
                                            </>
                                          );
                                        })()
                                      ) : (
                                        subject
                                      )}
                                    </td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIOutOf || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIObtainMarks || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIOutOf || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIObtainMarks || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.firstSemesterOutOf || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.firstSemesterObtainMarks || "AB"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      <b>{totalOutOf}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{totalObtainMarks}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{rowPercentage}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{grade}</b>
                                    </td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ padding: "5px" }}>
                                {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}

                          {selectedStudentResults && selectedStudentResults.results && (
                            <>
                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b>
                                </td>
                                {["unitTestIOutOf", "unitTestIObtainMarks", "unitTestIIOutOf", "unitTestIIObtainMarks", "firstSemesterOutOf", "firstSemesterObtainMarks"].map((key, index) => (
                                  <td key={index} colSpan="1" style={{ padding: "5px" }}>
                                    <b>
                                      {subjectSequence
                                        .filter(subject => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.firstSemesterObtainMarks;
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults.results[subject] || {};
                                          return total + (grades[key] || 0);
                                        }, 0)}
                                    </b>
                                  </td>
                                ))}
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.firstSemesterObtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.firstSemesterObtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.firstSemesterObtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
                                      }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.firstSemesterObtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
                                      }, 0);
                                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                                    })()}
                                  </b>
                                </td>
                              </tr>

                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Remarks" : "शेरा"}</b>
                                </td>

                                {/* Calculate and display the percentage for Unit Test I */}
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      // Filter subjects that have valid obtainMarks for the student
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        // Check if there is at least one obtainMarks greater than 0
                                        return grades.unitTestIObtainMarks > 0;
                                      });

                                      // Calculate total out of marks for Unit Test I
                                      const totalUnitTestIOutOf = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIOutOf || 0);
                                      }, 0);

                                      // Calculate total obtained marks for Unit Test I
                                      const totalUnitTestIObtained = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIObtainMarks || 0);
                                      }, 0);

                                      // Calculate percentage
                                      return totalUnitTestIOutOf > 0 ? ((totalUnitTestIObtained / totalUnitTestIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>

                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      // Filter subjects that have valid obtainMarks for Unit Test II
                                      const filteredSubjectsUnitTestII = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        // Check if there is at least one obtainMarks greater than 0 for Unit Test II
                                        return grades.unitTestIIObtainMarks > 0;
                                      });

                                      // Calculate total out of marks for Unit Test II
                                      const totalUnitTestIIOutOf = filteredSubjectsUnitTestII.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIOutOf || 0);
                                      }, 0);

                                      // Calculate total obtained marks for Unit Test II
                                      const totalUnitTestIIObtained = filteredSubjectsUnitTestII.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.unitTestIIObtainMarks || 0);
                                      }, 0);

                                      // Calculate percentage for Unit Test II
                                      return totalUnitTestIIOutOf > 0 ? ((totalUnitTestIIObtained / totalUnitTestIIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>

                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <>
                                    {(() => {
                                      // Filter subjects that have valid obtainMarks for Semester I
                                      const filteredSubjectsSemesterI = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        // Check if there is at least one obtainMarks greater than 0 for Semester I
                                        return grades.firstSemesterObtainMarks > 0;
                                      });

                                      // Calculate total out of marks for Semester I
                                      const totalSemesterIOutOf = filteredSubjectsSemesterI.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.firstSemesterOutOf || 0);
                                      }, 0);

                                      // Calculate total obtained marks for Semester I
                                      const totalSemesterIObtained = filteredSubjectsSemesterI.reduce((total, subject) => {
                                        const grades = selectedStudentResults.results[subject] || {};
                                        return total + (grades.firstSemesterObtainMarks || 0);
                                      }, 0);

                                      // Calculate percentage for Semester I
                                      return totalSemesterIOutOf > 0 ? ((totalSemesterIObtained / totalSemesterIOutOf) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </>
                                </td>

                                <td colSpan="4"></td>
                              </tr>
                            </>
                          )}
                        </tbody>






















                      </table>
                    ) : (
                      <p style={{ fontSize: '12px' }}>{language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
                    )}

                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence
                              .filter(subject => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.firstSemesterObtainMarks;
                              })
                              .reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                              }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English" ? "Obtained Marks : " : "प्राप्त गुण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults?.results?.[subject] || {};
                              return (
                                total +
                                (grades.unitTestIObtainMarks || 0) +
                                (grades.unitTestIIObtainMarks || 0) +
                                (grades.firstSemesterObtainMarks || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>

                        <p>
                          <strong>
                            {language === "English" ? "Remark : " : "शेरा : "}
                          </strong>
                          <span>
                            {selectedExamName === "Semester First "
                              ? selectedStudentResults?.firstSemesterRemark || '-'
                              : selectedExamName === "Semester Second "
                                ? selectedStudentResults?.secondSemesterRemark || '-'
                                : '-'}
                          </span>
                        </p>
                      </div>

                      <div style={{ marginTop: '-50px' }}>
                        <p>
                          <b>
                            {language === "English" ? "Percentage : " : "टक्केवारी : "}
                            {(() => {
                              // Filter subjects that have valid obtainMarks for Unit Test I and II
                              const filteredSubjects = subjectSequence.filter(subject => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                // Check if there is at least one obtainMarks greater than 0 for Unit Test I or II
                                return (
                                  grades.unitTestIObtainMarks > 0 ||
                                  grades.unitTestIIObtainMarks > 0 ||
                                  grades.firstSemesterObtainMarks > 0 // Changed from obtainMarks
                                );
                              });

                              // Calculate total maximum marks
                              const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIOutOf || 0) +
                                  (grades.unitTestIIOutOf || 0) +
                                  (grades.firstSemesterOutOf || 0) // Changed from outOf
                                );
                              }, 0);

                              // Calculate total obtained marks
                              const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.unitTestIObtainMarks || 0) +
                                  (grades.unitTestIIObtainMarks || 0) +
                                  (grades.firstSemesterObtainMarks || 0) // Changed from obtainMarks
                                );
                              }, 0);

                              // Calculate percentage
                              return totalMaxMarks > 0
                                ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                                : "0%";
                            })()}
                          </b>
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <p style={{ margin: 0, marginRight: '10px' }}><b>Attendance :</b></p>
                          <input
                            type="text"
                            id="attendance"
                            placeholder="Enter attendance"     value={attendance}
                            onChange={(e) => setAttendance(e.target.value)}
                            style={{
                              border: 'none',
                              borderBottom: '1px solid #ccc',
                              outline: 'none',
                              padding: '5px 0',
                              background: 'transparent',
                              width: '50px'
                            }}
                          />
                        </div>
                      </div>
                    </div>


                    <div
                      className="grad"
                      style={{
                        marginBottom: '50px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                      }}
                    >
                      {/* Left-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'left', marginBottom: '2px', marginLeft: '-10px' }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English" ? "Parent's Sign" : "पालकांची सही"}
                      </label>

                      {/* Center-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'center', marginBottom: '2px' }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Class Teacher's Sign" : "वर्गशिक्षक"}
                      </label>

                      {/* Right-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'right', marginBottom: '2px', marginRight: '20px' }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal's Sign" : "प्राचार्य"}
                      </label>
                    </div>

                  </div>
                </div>

              </div>





            ) : selectedExamName === 'Combined Result' && selectedStudentResults ? (




              <div className="r mt-1">
                <div className="left" style={{
                  width: '915px',
                  height: '690px',
                  margin: '0 auto',
                  padding: '20px',
                  border: '2px solid #000',
                  boxSizing: 'border-box',
                  overflow: 'hidden'
                }}>

                  <div className="school-header" style={{ marginBottom: '10px', position: 'relative' }}>
                    {/* Logo + School Name container */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      padding: '0 10px'
                    }}>
                      {/* Logo aligned left */}
                      {schoolLogo && (
                        <div style={{ flex: '0 0 auto' }}>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{
                              width: '70px',
                              height: 'auto',
                              objectFit: 'contain'
                            }}
                          />
                        </div>
                      )}

                      {/* School name centered */}
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <h4 style={{ fontSize: '22px', margin: 0 }}>{schoolName}</h4>
                      </div>

                      {/* Empty space to balance flex alignment */}
                      <div style={{ width: '70px' }}></div>
                    </div>
                    <div class="ribbon" > PROGRESS REPORT</div>
                    <style jsx >
                      {`
  /* HTML: <div class="ribbon">Your text content</div> */
.ribbon {
  font-size: 18px;
  font-weight: bold;
     display: table;
  color: #fff;

}
.ribbon {
  --s: 1.8em; /* the ribbon size */
  --d: .8em;  /* the depth */
  --c: .8em;  /* the cutout part */
  
  padding: 0 calc(var(--s) + .5em) var(--d);
  line-height: 1.8;
  background:
    conic-gradient(at left  var(--s) bottom var(--d),
     #0000 25%,#0008 0 37.5%,#0004 0) 0   /50% 100% no-repeat,
    conic-gradient(at right var(--s) bottom var(--d),
     #0004 62.5%,#0008 0 75%,#0000 0) 100%/50% 100% no-repeat;
  clip-path: polygon(0 var(--d), var(--s) var(--d),var(--s) 0,calc(100% - var(--s)) 0,calc(100% - var(--s)) var(--d),100% var(--d),calc(100% - var(--c)) calc(50% + var(--d)/2),100% 100%,calc(100% - var(--s) - var(--d)) 100%,calc(100% - var(--s) - var(--d)) calc(100% - var(--d)),calc(var(--s) + var(--d)) calc(100% - var(--d)),calc(var(--s) + var(--d)) 100%,0 100%,var(--c) calc(50% + var(--d)/2));
  background-color: #CC333F; /* the main color */
  width: fit-content;
   margin: 0px auto;
     display: table;
}
  `}
                    </style>


                    {/* </div> */}
                  </div>



                  <div style={{ marginTop: '-20px', fontSize: '12px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Left Section (Student Details) */}
                    <div style={{ width: '70%' }}>
                      <div>
                        <label htmlFor="student-name" style={{ fontSize: '12px' }}>{language === "English" ? "Student's Name : " : "विद्यार्थ्याचे नाव : "}</label>
                        <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                      </div>
                      <div>
                        <label htmlFor="class" style={{ fontSize: '12px' }}>{language === "English" ? "Mother's Name : " : "आईचे वर्ग : "}</label>
                        <span>{selectedStudentResults?.stdMother || '-'} </span>
                      </div>
                      <div>
                        <label htmlFor="class" style={{ fontSize: '12px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                        <span>
                          {selectedStudentResults?.dob ?
                            `${new Date(selectedStudentResults.dob).getDate().toString().padStart(2, '0')}/${(new Date(selectedStudentResults.dob).getMonth() + 1).toString().padStart(2, '0')}/${new Date(selectedStudentResults.dob).getFullYear()}`
                            : '-'}
                        </span>
                      </div>
                      <div>
                        <label htmlFor="exam-roll-no" style={{ fontSize: '12px' }}>{language === "English" ? "Year : " : "शैक्षणिक वर्ष : "}</label>
                        <span>{academicYear || '-'}</span>
                      </div>
                    </div>

                    {/* Middle Section (Roll No, Register No, Class) */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', flex: '1', marginRight: '20px' }}>
                      <div>
                        <label htmlFor="roll-no" style={{ fontSize: '12px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div>
                        <label htmlFor="Register No" style={{ fontSize: '12px' }}>{language === "English" ? "GR No: " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                       <div style={{ flex: '1', textAlign: 'right' }}>
  <label htmlFor="class" style={{ fontSize: '14px' }}>
    {language === "English" ? "  " : "वर्ग : "}
  </label>
  <span>
    {/* Show current class or previous year class if available */}
    {previousYearClass 
      ? `${previousYearClass} `
      : classValue || '-'}
    {/* Show division if available */}
    {selectedStudentResults?.division ? ` ${selectedStudentResults.division}` : ''}
  </span>
</div>
                    </div>

                    {/* Right Section (Student Image) */}
                    <div style={{ width: '30%', marginRight: '-150px' }}>
                      {selectedStudentResults?.stdPhoto && (
                        <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                      )}
                    </div>
                  </div>

                  {selectedStudentResults?.results ? (
                    <table className="table table-striped table-bordered" style={{ fontSize: '10px', padding: '5px', marginTop: '10px' }}>
                      <thead>
                        <tr>
                          <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test I" : "प्रथम चाचणी"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test II" : "द्वितीय चाचणी"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test III" : "तृतीय चाचणी"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test IV" : "चतुर्थ चाचणी"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Sem-I" : "प्रथम सत्र"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Sem-II" : "द्वितीय सत्र"}</th>
                          <th colSpan="1" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Total" : "एकूण"}</th>
                          <th colSpan="1" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Percentage" : "%"}</th>
                          <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
                        </tr>
                        <tr>
                          {/* Unit Test I */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Unit Test II */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Unit Test III */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Unit Test IV */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Semester I */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Semester II */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Total */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Percentage */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "%" : "%"}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {selectedStudentResults && selectedStudentResults.results ? (
                          subjectSequence
                            .filter((subject) => {
                              const grades = selectedStudentResults.results[subject];
                              console.log("selectedStudentResults3333", selectedStudentResults)
                              return grades && (
                                grades.unitTestIObtainMarks ||
                                grades.unitTestIIObtainMarks ||
                                grades.unitTestIIIObtainMarks ||
                                grades.unitTestIVObtainMarks ||
                                grades.firstSemesterObtainMarks ||
                                grades.obtainMarks

                              );
                            })
                            .map((subject) => {
                              const grades = selectedStudentResults.results[subject];

                              const totalOutOf = (
                                (grades.unitTestIOutOf || 0) +
                                (grades.unitTestIIOutOf || 0) +
                                (grades.unitTestIIIOutOf || 0) +
                                (grades.unitTestIVOutOf || 0) +
                                (grades.firstSemesterOutOf || 0) +
                                (grades.outOf || 0)
                              );
                              
                              const totalObtainMarks = (
                                (grades.unitTestIObtainMarks || 0) +
                                (grades.unitTestIIObtainMarks || 0) +
                                (grades.unitTestIIIObtainMarks || 0) +
                                (grades.unitTestIVObtainMarks || 0) +
                                (grades.firstSemesterObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );

                              const rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                              const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                              return (
                                <tr key={subject} style={{ padding: "2px" }}>
                                  <td style={{ padding: "2px", color: 'black' }}>
                                    {subject.length > 20 ? (
                                      (() => {
                                        const words = subject.split(' ');
                                        let firstLine = '';
                                        let secondLine = '';
                                        let currentLength = 0;

                                        for (let i = 0; i < words.length; i++) {
                                          if (currentLength + words[i].length > 20) {
                                            secondLine = words.slice(i).join(' ');
                                            break;
                                          }
                                          firstLine += (i > 0 ? ' ' : '') + words[i];
                                          currentLength += words[i].length + (i > 0 ? 1 : 0);
                                        }

                                        return (
                                          <>
                                            {firstLine}<br />{secondLine}
                                          </>
                                        );
                                      })()
                                    ) : (
                                      subject
                                    )}
                                  </td>

                                  {/* Unit Test I */}
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIOutOf || "AB"}</td>
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIObtainMarks || "AB"}</td>

                                  {/* Unit Test II */}
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIOutOf || "AB"}</td>
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIObtainMarks || "AB"}</td>

                                  {/* Unit Test III */}
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIIOutOf || "AB"}</td>
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIIIObtainMarks || "AB"}</td>

                                  {/* Unit Test IV */}
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIVOutOf || "AB"}</td>
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.unitTestIVObtainMarks || "AB"}</td>

                                  {/* Semester I */}
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.firstSemesterOutOf || "AB"}</td>
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.firstSemesterObtainMarks || "AB"}</td>

                                  {/* Semester II */}
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.outOf
                                    || grades.outOf || "AB"}</td>
                                  <td style={{ padding: "2px", color: 'black' }}>{grades.obtainMarks || "AB"}</td>

                                  {/* Total */}
                                  <td style={{ padding: "2px" }}><b>{totalObtainMarks}</b></td>

                                  {/* Percentage */}
                                  <td style={{ padding: "2px" }}><b>{rowPercentage}</b></td>

                                  {/* Grade */}
                                  <td style={{ padding: "2px" }}><b>{grade}</b></td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="17" style={{ padding: "5px" }}>
                              {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                            </td>
                          </tr>
                        )}

                        {selectedStudentResults && selectedStudentResults.results && (
                          <tr>
                            <td colSpan="1" style={{ padding: "5px" }}>
                              <b>{language === "English" ? "TOTAL" : "एकूण"}</b>
                            </td>

                            {/* Calculate and display total marks for each column */}
                            {/* Unit Test I Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIOutOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Unit Test I Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIObtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Unit Test II Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIIOutOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Unit Test II Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIIObtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Unit Test III Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIIIOutOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Unit Test III Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIIIObtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Unit Test IV Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIVOutOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Unit Test IV Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.unitTestIVObtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Semester I Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.firstSemesterOutOf || grades.firstSemesterObtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.firstSemesterOutOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Semester I Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.firstSemesterOutOf || grades.firstSemesterObtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.firstSemesterObtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Semester II Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    console.log("grades",grades)
                                    return grades.outOf || grades.obtainMarks ;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.outOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Semester II Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.outOf || grades.obtainMarks ;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.obtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Grand Total Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                      (grades.unitTestIObtainMarks || 0) +
                                      (grades.unitTestIIObtainMarks || 0) +
                                      (grades.unitTestIIIObtainMarks || 0) +
                                      (grades.unitTestIVObtainMarks || 0) +
                                      (grades.firstSemesterObtainMarks || 0) +
                                      (grades.obtainMarks || 0);

                                  }, 0)}
                              </b>
                            </td>

                            {/* Overall Percentage */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {(() => {
                                  const filteredSubjects = subjectSequence.filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  });

                                  const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                      (grades.unitTestIOutOf || 0) +
                                      (grades.unitTestIIOutOf || 0) +
                                      (grades.unitTestIIIOutOf || 0) +
                                      (grades.unitTestIVOutOf || 0) +
                                      (grades.firstSemesterOutOf || 0) +
                                      (grades.outOf || 0);

                                  }, 0);

                                  const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {

                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                      (grades.unitTestIObtainMarks || 0) +
                                      (grades.unitTestIIObtainMarks || 0) +
                                      (grades.unitTestIIIObtainMarks || 0) +
                                      (grades.unitTestIVObtainMarks || 0) +
                                      (grades.firstSemesterObtainMarks || 0) +
                                      (grades.obtainMarks || 0);
                                  }, 0);

                                  return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) : "0";
                                })()}
                              </b>
                            </td>
                            {/* Overall Grade */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {(() => {
                                  const filteredSubjects = subjectSequence.filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks ||
                                      grades.unitTestIVObtainMarks || grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  });

                                  const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                      (grades.unitTestIOutOf || 0) +
                                      (grades.unitTestIIOutOf || 0) +
                                      (grades.unitTestIIIOutOf || 0) +
                                      (grades.unitTestIVOutOf || 0) +
                                      (grades.firstSemesterOutOf || 0) +
                                      (grades.outOf || 0);
                                  }, 0);

                                  const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                      (grades.unitTestIObtainMarks || 0) +
                                      (grades.unitTestIIObtainMarks || 0) +
                                      (grades.unitTestIIIObtainMarks || 0) +
                                      (grades.unitTestIVObtainMarks || 0) +
                                      (grades.firstSemesterObtainMarks || 0) +
                                      (grades.obtainMarks || 0);
                                  }, 0);

                                  const percentage = totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100) : 0;
                                  return calculateGrade(percentage);
                                })()}
                              </b>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ textAlign: 'center', margin: '20px 0' }}>
                      {language === "English" ? "No results data available" : "परिणाम डेटा उपलब्ध नाही"}
                    </div>
                  )}

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p style={{ margin: 0, marginRight: '10px', fontSize: '14px' }}><b>Attendance :</b></p>
                    <input
                      type="text"
                      id="attendance"
                      placeholder="Enter attendance"
                      value={attendance}
                      onChange={(e) => setAttendance(e.target.value)}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid transparent',
                        outline: 'none',
                        padding: '5px 0',
                        background: 'transparent',
                        width: '100px' // Add this line to set the width
                        , fontSize: '12px'
                      }}
                    />

                    <p style={{ margin: '0 10px', fontSize: '14px' }}><b>Teacher's  Remark : </b></p>
                    <input
                      type="text"
                      id="remark-input"
                      placeholder="Enter Remark"
  value={remarkText}
  onChange={(e) => setRemarkText(e.target.value)}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid transparent',
                        outline: 'none',
                        padding: '5px 0',
                        background: 'transparent',
                        width: '510px',
                        fontSize: '12px'
                      }}
                    />
                  </div>


                  <div
                    className="grad"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0 20px", height: '50px',
                      position: 'sticky', top: '630px'
                    }}
                  >
                    {/* Left-aligned label and date input */}
                    <div className='parent-area' style={{ textAlign: "left", marginTop: '29px' }}>
                      <label
                        style={{
                          marginBottom: "0px",
                        }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "PARENT" : "पालक"}
                      </label>
                      <div>
                        {language === "English" ? (
                          <div>
                            <label htmlFor="date" style={{ marginRight: "8px" }}>
                              Date:
                            </label>
                            <input
                              type="date"
                              id="date" value={selectedDate}
  onChange={(e) => {
    setSelectedDate(e.target.value);
    setDateSelected(!!e.target.value);
  }}
                              style={{
                                padding: "2px 4px",
                                width: "150px",
                                border: "none",
                                ...(dateSelected && {
                                  appearance: "none",
                                  WebkitAppearance: "none",
                                }),
                              }}
                              className={dateSelected ? "hide-picker" : ""}
                            />
                          </div>
                        ) : (
                          <label htmlFor="parent-sign">दिनांक</label>
                        )}
                      </div>


                    </div>
                    {/* Center-aligned label */}
                    <label
                      style={{
                        flex: 1,
                        textAlign: "center",
                        marginBottom: "2px",
                      }}
                      htmlFor="class-teacher"
                    >
                      {language === "English" ? "CLASS TEACHER" : "वर्गशिक्षक"}
                    </label>

                    {/* Right-aligned label */}
                    <label
                      style={{
                        flex: 1,
                        textAlign: "right",
                        marginBottom: "2px",
                        marginRight: "20px",
                      }}
                      htmlFor="principal"
                    >
                      {language === "English" ? "PRINCIPAL" : "प्राचार्य"}
                    </label>

                    <style jsx>{`
        .hide-picker::-webkit-calendar-picker-indicator {
          display: none;
        }
      `}</style>
                  </div>


                  <style jsx>{`
  .no-picker::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`}</style>





                </div>


                <Button variant="primary" onClick={handlePrit} style={{ float: 'right' }}>
                  {language === "English" ? "Print" : "Print करा"}
                </Button>
              </div>



            ) : (















              <div className="r mt-1">
                <div className="left" style={{
                  width: '615px',
                  height: '900px',
                  margin: '0 auto',
                  padding: '20px',
                  border: '2px solid #000',
                  boxSizing: 'border-box',
                  overflow: 'hidden'
                }}>

<div style={{ width: '100%', marginBottom: '20px', position: 'relative' }}>
  {schoolLogo && (
    <div style={{ position: 'absolute', left: '0', top: '50%', transform: 'translateY(-50%)', zIndex: '1' }}>
      <img
        src={schoolLogo}
        alt="Logo"
        style={{ width: '70px', height: 'auto', objectFit: 'contain' }}
      />
    </div>
  )}
  <div style={{ 
    width: '100%', 
    textAlign: 'center',
    position: 'relative',
    zIndex: '0'
  }}>
    {sansthaName && <p style={{ fontSize: '13px', marginBottom: '0', color: 'black', textAlign: 'center' }}>{sansthaName}</p>}
    <h6 style={{ fontSize: '18px', margin: '0px 0', textAlign: 'center' }}>{schoolName}</h6>

    <div style={{ fontSize: '13px', color: 'black', marginTop: '5px', textAlign: 'center' }}>
     {taluka && jilha && (
        <p style={{ margin: '2px 0', textAlign: 'center' }}>
         {language === "English" ? "Taluka : " : "तालुका :"} {taluka},    {language === "English" ? "District : " : "जिल्हा :"} {jilha}
        </p>
      )}
      <div style={{ marginTop: '5px', fontSize: '12px', textAlign: 'center' }}>
        {mobileNumber && <span>  {language === "English" ? "Phone No. : " : "फोन नं. :"}  {mobileNumber}</span>}
        { udiseNumberDisplay &&  <span style={{ margin: '2px 0', textAlign: 'center' }}>, UDISE No. : {udiseNumberDisplay}</span>}
      </div>
      {email && <p  style={{ marginLeft: '5px' }}> {language === "English" ? "Email : " : "ईमेल :"}{email} </p>}
     
    </div>
  </div>
</div>

                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "FINAL SEMESTER " : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `REPORT CARD ACADEMIC YEAR ${academicYear}` : `प्रथम सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "GR No: " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right' }}>
  <label htmlFor="class" style={{ fontSize: '14px' }}>
    {language === "English" ? "  " : "वर्ग : "}
  </label>
  <span>
    {/* Show current class or previous year class if available */}
    {previousYearClass 
      ? `${previousYearClass} `
      : classValue || '-'}
    {/* Show division if available */}
    {selectedStudentResults?.division ? ` ${selectedStudentResults.division}` : ''}
  </span>
</div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student's Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother's Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>
                            {selectedStudentResults?.dob ?
                              `${new Date(selectedStudentResults.dob).getDate().toString().padStart(2, '0')}/${(new Date(selectedStudentResults.dob).getMonth() + 1).toString().padStart(2, '0')}/${new Date(selectedStudentResults.dob).getFullYear()}`
                              : '-'}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>

                  {selectedStudentResults?.results ? (
                    <table className="table table-striped table-bordered" style={{ fontSize: '10px', padding: '5px', marginTop: '10px' }}>
                      <thead>
                        <tr>
                          <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Sem-I" : "प्रथम सत्र"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Sem-II" : "द्वितीय सत्र"}</th>
                          <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Total" : "एकूण"}</th>
                          <th colSpan="1" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Percentage" : "%"}</th>
                          <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
                        </tr>
                        <tr>
                          
                          {/* Semester I */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Semester II */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "पैकी"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                           {/* Total */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Max.M" : "गुण"}</th>
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>

                          {/* Percentage */}
                          <th style={{ padding: '3px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "%" : "%"}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {selectedStudentResults && selectedStudentResults.results ? (
                          subjectSequence
                            .filter((subject) => {
                              const grades = selectedStudentResults.results[subject];
                              console.log("selectedStudentResults3333", selectedStudentResults)
                              return grades && (
                                
                                grades.firstSemesterObtainMarks ||
                                grades.obtainMarks ||
                                grades.firstSemesterGrade ||
                                grades.secondSemesterGrade

                              );
                            })
                            .map((subject) => {
                              const grades = selectedStudentResults.results[subject];
                              const hasGrade = grades.grade !== undefined;
                              const hasFirstSemesterGrade = grades.firstSemesterGrade !== undefined;
                              const hasSecondSemesterGrade = grades.secondSemesterGrade !== undefined;

                              const totalOutOf = (
                               
                                (grades.firstSemesterOutOf || 0) +
                                (grades.outOf || 0) 
                              );
                              
                              const totalObtainMarks = (
                               
                                (grades.firstSemesterObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );

                              const rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                              const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                              return (
                                <tr key={subject} style={{ padding: "2px" }}>
                                  <td style={{ padding: "2px", color: 'black' }}>
                                    {subject.length > 20 ? (
                                      (() => {
                                        const words = subject.split(' ');
                                        let firstLine = '';
                                        let secondLine = '';
                                        let currentLength = 0;

                                        for (let i = 0; i < words.length; i++) {
                                          if (currentLength + words[i].length > 20) {
                                            secondLine = words.slice(i).join(' ');
                                            break;
                                          }
                                          firstLine += (i > 0 ? ' ' : '') + words[i];
                                          currentLength += words[i].length + (i > 0 ? 1 : 0);
                                        }

                                        return (
                                          <>
                                            {firstLine}<br />{secondLine}
                                          </>
                                        );
                                      })()
                                    ) : (
                                      subject
                                    )}
                                  </td>

                                  
                                  {/* Semester I */}
                                   {/* Semester I */}
          <td style={{ padding: "2px", color: 'black' }}>
            {hasFirstSemesterGrade ? "-" : grades.firstSemesterOutOf || "AB"}
          </td>
          <td style={{ padding: "2px", color: 'black' }}>
            {hasFirstSemesterGrade ? grades.firstSemesterGrade || "-" : grades.firstSemesterObtainMarks || "AB"}
          </td>

          {/* Semester II */}
          <td style={{ padding: "2px", color: 'black' }}>
            {hasSecondSemesterGrade ? "-" : grades.outOf || "AB"}
          </td>
          <td style={{ padding: "2px", color: 'black' }}>
            {hasSecondSemesterGrade ? grades.secondSemesterGrade || "-" : grades.obtainMarks || "AB"}
          </td>
                                  
                                  {/* Total */}
                                  <td style={{ padding: "2px" }}><b>{hasGrade ? "-" :totalOutOf}</b></td>
                   
                                  {/* Total */}
                                  <td style={{ padding: "2px" }}><b>{hasGrade ? "-" :totalObtainMarks}</b></td>

                                  {/* Percentage */}
                                  <td style={{ padding: "2px" }}><b>{hasGrade ? "-" :rowPercentage}</b></td>

                                  {/* Grade */}
                                  <td style={{ padding: "2px" }}><b>{hasGrade ? grades.grade : grade}</b></td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="17" style={{ padding: "5px" }}>
                              {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                            </td>
                          </tr>
                        )}

                        {selectedStudentResults && selectedStudentResults.results && (
                          <tr>
                            <td colSpan="1" style={{ padding: "5px" }}>
                              <b>{language === "English" ? "TOTAL" : "एकूण"}</b>
                            </td>

                            {/* Semester I Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter((subject) => {
  const grades = selectedStudentResults.results[subject];
  return grades && (
    grades.firstSemesterObtainMarks ||
    grades.obtainMarks ||
    grades.grade  // Including subjects with grades
  );
})
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.firstSemesterOutOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Semester I Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter((subject) => {
  const grades = selectedStudentResults.results[subject];
  return grades && (
    grades.firstSemesterObtainMarks ||
    grades.obtainMarks ||
    grades.grade  // Including subjects with grades
  );
})
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.firstSemesterObtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Semester II Max */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter((subject) => {
  const grades = selectedStudentResults.results[subject];
  return grades && (
    grades.firstSemesterObtainMarks ||
    grades.obtainMarks ||
    grades.grade  // Including subjects with grades
  );
})
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.outOf || 0);
                                  }, 0)}
                              </b>
                            </td>

                            {/* Semester II Obtained */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {subjectSequence
                                  .filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return grades.outOf || grades.obtainMarks ;
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total + (grades.obtainMarks || 0);
                                  }, 0)}
                              </b>
                            </td>


 {/* Grand Total outof */}
                            <td style={{ padding: "5px" }}>
  <b>
    {subjectSequence
      .filter(subject => {
        const grades = selectedStudentResults.results[subject] || {};
        return grades.firstSemesterOutOf || grades.outOf;
      })
      .reduce((total, subject) => {
        const grades = selectedStudentResults.results[subject] || {};
        return total + (grades.firstSemesterOutOf || 0) + (grades.outOf || 0);
      }, 0)}
  </b>
</td>


                            {/* Grand Total Obtained */}
                            <td style={{ padding: "5px" }}>
  <b>
    {subjectSequence
      .filter(subject => {
        const grades = selectedStudentResults.results[subject] || {};
        return grades.firstSemesterObtainMarks || grades.obtainMarks;
      })
      .reduce((total, subject) => {
        const grades = selectedStudentResults.results[subject] || {};
        return total + (grades.firstSemesterObtainMarks || 0) + (grades.obtainMarks || 0);
      }, 0)}
  </b>
</td>

                            {/* Overall Percentage */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {(() => {
                                  const filteredSubjects = subjectSequence.filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return  grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  });

                                  const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                   
                                      (grades.firstSemesterOutOf || 0) +
                                      (grades.outOf || 0);

                                  }, 0);

                                  const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {

                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                      
                                      (grades.firstSemesterObtainMarks || 0) +
                                      (grades.obtainMarks || 0);
                                  }, 0);

                                  return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) : "0";
                                })()}
                              </b>
                            </td>
                            {/* Overall Grade */}
                            <td style={{ padding: "5px" }}>
                              <b>
                                {(() => {
                                  const filteredSubjects = subjectSequence.filter(subject => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return  grades.firstSemesterObtainMarks || grades.obtainMarks;
                                  });

                                  const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                      
                                      (grades.firstSemesterOutOf || 0) +
                                      (grades.outOf || 0);
                                  }, 0);

                                  const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject] || {};
                                    return total +
                                     
                                      (grades.firstSemesterObtainMarks || 0) +
                                      (grades.obtainMarks || 0);
                                  }, 0);

                                  const percentage = totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100) : 0;
                                  return calculateGrade(percentage);
                                })()}
                              </b>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ textAlign: 'center', margin: '20px 0' }}>
                      {language === "English" ? "No results data available" : "परिणाम डेटा उपलब्ध नाही"}
                    </div>
                  )}


                  <div>
  <p style={{ margin: '0 10px', fontSize: '14px', display: 'inline-block' }}><b>Teacher's  Remark : </b></p>
  <input
    type="text"
    id="remark-input"
    placeholder="Enter Remark"
    value={remarkText}
    onChange={(e) => setRemarkText(e.target.value)}
    style={{
      border: 'none',
      borderBottom: '1px solid transparent',
      outline: 'none',
      padding: '5px 0',
      background: 'transparent',
      width: '410px',
      fontSize: '12px',
      display: 'inline-block'
    }}
  />
</div>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p style={{ margin: 0, marginRight: '10px', fontSize: '14px' }}><b>Attendance :</b></p>
                    <input
                      type="text"
                      id="attendance"
                      placeholder="Enter attendance"
                      value={attendance}
                      onChange={(e) => setAttendance(e.target.value)}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid transparent',
                        outline: 'none',
                        padding: '5px 0',
                        background: 'transparent',
                        width: '100px' // Add this line to set the width
                        , fontSize: '12px'
                      }}
                    />
                    </div>

                    


                  <div
                    className="grad"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0 20px", height: '170px',
                      position: 'sticky', top: '630px'
                    }}
                  >
                    {/* Left-aligned label and date input */}
                    <div className='parent-area' style={{ textAlign: "left", marginTop: '29px' }}>
                      <label
                        style={{
                          marginBottom: "0px",
                        }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "PARENT" : "पालक"}
                      </label>
                      <div>
                        {language === "English" ? (
                          <div>
                            <label htmlFor="date" style={{ marginRight: "8px" }}>
                              Date:
                            </label>
                            <input
                              type="date"
                              id="date" value={selectedDate}
              onChange={(e) => {
              setSelectedDate(e.target.value);
              setDateSelected(!!e.target.value);
              }}
                              style={{
                                padding: "2px 4px",
                                width: "150px",
                                border: "none",
                                ...(dateSelected && {
                                  appearance: "none",
                                  WebkitAppearance: "none",
                                }),
                              }}
                              className={dateSelected ? "hide-picker" : ""}
                            />
                          </div>
                        ) : (
                          <label htmlFor="parent-sign">दिनांक</label>
                        )}
                      </div>


                    </div>
                    {/* Center-aligned label */}
                    <label
                      style={{
                        flex: 1,
                        textAlign: "center",
                        marginBottom: "2px",
                      }}
                      htmlFor="class-teacher"
                    >
                      {language === "English" ? "CLASS TEACHER" : "वर्गशिक्षक"}
                    </label>

                    {/* Right-aligned label */}
                    <label
                      style={{
                        flex: 1,
                        textAlign: "right",
                        marginBottom: "2px",
                        marginRight: "20px",
                      }}
                      htmlFor="principal"
                    >
                      {language === "English" ? "PRINCIPAL" : "प्राचार्य"}
                    </label>

                    <style jsx>{`
              .hide-picker::-webkit-calendar-picker-indicator {
              display: none;
              }
              `}</style>
                  </div>


                  <style jsx>{`
              .no-picker::-webkit-calendar-picker-indicator {
              display: none;
              -webkit-appearance: none;
              }
              `}</style>

                </div>
              </div>

            )}

          </Modal.Body>
          <Modal.Footer>
          <Button variant="primary" onClick={handleSaveADR} style={{ marginRight: '10px' }}>
    {language === "English" ? "Save Details" : "तपशील जतन करा"}
  </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              {language === "English" ? " Close " : "Close करा"}
            </Button>
            {selectedExamName !== "Combined Result" && (
              <Button variant="primary" onClick={handlePrint}>
                {language === "English" ? "Print" : "Print करा"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

      </div>
    </div>
  );
};

export default IcseResult;
